import { FC } from 'react';
import {
  USER_CLICK_RECOMMENDJOBLIST,
  USER_CLICK_SAVEDCONDITIONLIST,
  generateUrl,
} from 'components/FollowSearchResultsNavigation/logics/generateUrl';
import { useRouter } from 'next/router';
import { Button } from '@doda/io-react/common';
import { SavedSearchResponse } from '@doda/api-client/aspida/@types';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import styles from './index.module.scss';
import { EmptyDisplay } from '../EmptyDisplay';
import { ACCORDION_ITEMS } from '../../constants';

/**
 * SavedSearches コンポーネントのプロパティ
 */
interface Props {
  /** 保存された検索条件リスト */
  savedSearchesList: SavedSearchResponse[];
  /** メニューを閉じるクリック関数 */
  onClickMenuClose: () => void;
  /** ログイン判定 */
  loginStatus: boolean;
}

/**
 * SavedSearches コンポーネント
 * @param {Props} props - SavedSearches コンポーネントのプロパティ
 * @returns {JSX.Element} レンダリングされたコンポーネント
 */
export const SavedSearches: FC<Props> = ({
  savedSearchesList,
  onClickMenuClose,
  loginStatus,
}) => {
  const router = useRouter();

  /**
   * おすすめ一覧画面URLの生成関数
   * @param {number} savedNum - 保存された検索条件の番号
   * @returns {string} 生成されたおすすめ一覧URL
   */
  const createRecommendJobListUrl = (savedNum: number): string => {
    const path = `${DODA_SITE_URL.recommendJobList}?mpsc_dtno=${savedNum}`;
    const url = generateUrl({
      baseUrl: path,
      userClickList: USER_CLICK_RECOMMENDJOBLIST,
      pathname: router.pathname,
      loginStatus,
    });
    return url;
  };

  if (!savedSearchesList.length) {
    // 保存された検索条件リストが空の場合
    return (
      <EmptyDisplay
        label={ACCORDION_ITEMS.savedSearches.label}
        onClick={onClickMenuClose}
      />
    );
  }

  return (
    <>
      <div className={styles.savedSearchesContentsWrapper}>
        <ul className={styles.savedSearchesContentsWrapper__lists}>
          {savedSearchesList?.map(({ no, name }) => (
            <li
              key={no}
              className={styles.savedSearchesContentsWrapper__listItem}
            >
              <a href={createRecommendJobListUrl(no)}>
                <p className={styles.savedSearchesContentsWrapper__label}>
                  検索条件{no}
                </p>
                <p className={styles.savedSearchesContentsWrapper__name}>
                  {name}
                </p>
              </a>
            </li>
          ))}
        </ul>
        <div className={styles.savedSearchesContentsWrapper__btmArea}>
          {/* TODO:装飾で下線が付くためラップしています */}
          <div className={styles.savedSearchesContentsWrapper__btnWrap}>
            <Button
              as="a"
              href={generateUrl({
                baseUrl: DODA_SITE_URL.savedConditionList,
                userClickList: USER_CLICK_SAVEDCONDITIONLIST,
                pathname: router.pathname,
                loginStatus,
              })}
              size="S"
              variant="green"
            >
              保存した検索条件の変更
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
